import React, { useState, useEffect } from 'react';
import './ImageSlideshow.css'; // Import the CSS file

// Import local images
import slide1 from '../assets/image1.jpg';
import slide2 from '../assets/image2.jpg';
import slide3 from '../assets/image3.jpg';
import slide4 from '../assets/image4.jpg';
import slide5 from '../assets/image5.jpg';
import slide6 from '../assets/image6.jpg';
import slide7 from '../assets/image7.jpg';
import slide8 from '../assets/image8.jpg';
import slide9 from '../assets/image9.jpg';
import slide10 from '../assets/image10.jpg';
import slide11 from '../assets/image11.jpg';
import slide12 from '../assets/image12.jpg';
import slide13 from '../assets/image13.jpg';
import slide14 from '../assets/image14.jpg';

// Create an array of images
const images = [slide1, slide2, slide3, slide4, slide5, slide6, slide7, slide8, slide9, slide10, slide11, slide12,slide13,slide14];

const ImageSlideshow = () => {
 const [currentIndex, setCurrentIndex] = useState(0);
 const [transitionDirection, setTransitionDirection] = useState(0); // -1 for left, 1 for right

 useEffect(() => {
   const intervalId = setInterval(() => {
     setTransitionDirection(1); // set to next slide
     setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
   }, 3000); // Change slide every 3 seconds

   return () => clearInterval(intervalId); // Cleanup for interval
 }, []);

 const nextSlide = () => {
   setTransitionDirection(1);
   setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
 };

 const prevSlide = () => {
   setTransitionDirection(-1);
   setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
 };

 return (
   <div className="slideshow-container">
     <div className="slideshow">
       {images.map((image, index) => (
         <div
           key={index}
           className={`slide ${index === currentIndex ? 'active' : ''} ${transitionDirection === 1 ? 'next' : 'prev'}`}
         >
           <img src={image} alt={`Slide ${index + 1}`} />
         </div>
       ))}
     </div>
     <div className="controls">
       <button onClick={prevSlide}>&lt;</button>
       <button onClick={nextSlide}>&gt;</button>
     </div>
   </div>
 );
};

export default ImageSlideshow;
